import React, { forwardRef } from 'react';
import {
  PALETTE, FONT_SERIF, FONT_SANS, FONT_MONO,
  HaleMark, ToxIntelMark, AgMark, Backplate, Eyebrow, Headline, Body, Rule, BrandLockup,
} from './primitives';

/* Asset 6 — Pilot Announcement Graphic
 *
 * Wide hero card. Headline-led, no imagery. Used for blog headers and
 * pinned posts. Hierarchy is locked: HALE first, ToxIntel second,
 * Agyekum Group as scientific review partner (never above Hale). */

const VB_W = 1600;
const VB_H = 900;

const PilotAnnouncementAsset = forwardRef(function PilotAnnouncementAsset(_props, ref) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${VB_W} ${VB_H}`}
      width="100%"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="Hale pilot announcement"
    >
      <Backplate w={VB_W} h={VB_H} />

      {/* Diagonal coral accent band — visual interest without imagery */}
      <g opacity={0.08}>
        <polygon points="1100,0 1600,0 1600,560 920,900 720,900" fill={PALETTE.CORAL} />
      </g>

      {/* Top brand strip — locked hierarchy: HALE primary */}
      <HaleMark x={80} y={80} w={150} h={62} fontSize={44} />
      <text x={250} y={102} fill={PALETTE.MUTED} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
        POWERED BY
      </text>
      <ToxIntelMark x={250} y={132} fontSize={26} />

      <text x={VB_W - 80} y={102} textAnchor="end" fill={PALETTE.MUTED} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
        SCIENTIFIC REVIEW PARTNER
      </text>
      <g transform={`translate(${VB_W - 80},132)`}>
        <text x={0} y={0} textAnchor="end" fill={PALETTE.SLATE} fontFamily={FONT_SERIF} fontWeight={600} fontSize={24}>
          The Agyekum Group
        </text>
      </g>

      <Rule x1={80} x2={VB_W - 80} y={196} />

      {/* Headline */}
      <Eyebrow x={80} y={266} text="Pilot launch · 2026" />
      <Headline x={80} y={388} text="Hale launches independent" size={84} />
      <Headline x={80} y={482} text="product review pilot." size={84} italic color={PALETTE.CORAL} />

      <Body
        x={80}
        y={566}
        size={24}
        color={PALETTE.SLATE}
        weight={500}
        lineHeight={1.45}
        text={[
          'Powered by ToxIntel.',
          'Scientific review by The Agyekum Group.',
        ]}
      />

      {/* Three highlights */}
      <g transform="translate(80,740)">
        {[
          { k: 'TWO PATHWAYS',         v: 'Reviewed™ + Verified™' },
          { k: 'INDEPENDENT',          v: 'Toxicologist sign-off' },
          { k: 'PORTABLE',             v: 'Retailer documentation' },
        ].map((s, i) => (
          <g key={s.k} transform={`translate(${i * 460},0)`}>
            <rect x={0} y={0} width={3} height={64} fill={PALETTE.CORAL} />
            <text x={20} y={20} fill={PALETTE.CORAL} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
              {s.k}
            </text>
            <text x={20} y={56} fill={PALETTE.SLATE} fontFamily={FONT_SERIF} fontWeight={700} fontSize={26}>
              {s.v}
            </text>
          </g>
        ))}
      </g>

      <text x={80} y={VB_H - 30} fill={PALETTE.MUTED} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
        HALE × TOXINTEL · INDEPENDENT GOVERNANCE INFRASTRUCTURE
      </text>
      <text x={VB_W - 80} y={VB_H - 30} textAnchor="end" fill={PALETTE.MUTED} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
        thehale.co
      </text>
    </svg>
  );
});

export default PilotAnnouncementAsset;
